import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {ParametrosEmpleadoModel} from "../model/parametrosEmpleado.model";

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionEmpleadoService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.getAll);
  }

  getAllEmpleados() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.getAllEmpleados);
  }

  cargaMasivaParamatrosEmpleados(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.cargaMasiva, payload);
  }

  guardarParametrosEmpleado(parametroEmpleadoList: Array<ParametrosEmpleadoModel>) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.create + '', parametroEmpleadoList);
  }

  actualizarParametrosEmpleado(parametroEmpleadoList: ParametrosEmpleadoModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.update + parametroEmpleadoList.id + '', parametroEmpleadoList);
  }

  borrarParametrosEmpleado(parametroEmpleadoList: ParametrosEmpleadoModel) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.empleado.delete + parametroEmpleadoList.id + '');
  }

}
